<template>
  <div>
    <b-form v-if="userRms">
      <b-card class="mb-3">
        <b-card-header
          class="d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0">
            <i class="bi bi-sliders"></i> Configuração de Campos
          </h5>
          <b-button
            variant="outline-primary"
            size="sm"
            @click="toggleAllConfigs"
          >
            {{ allExpanded ? "Recolher Todos" : "Expandir Todos" }}
          </b-button>
        </b-card-header>
        <b-card-body>
          <div v-for="c in config" :key="c.fieldId">
            <div v-if="c.fieldId != 900000025">
              <div class="field-container mb-4 pb-3"></div>
              <div class="d-flex justify-content-between align-items-center">
                <h4>{{ c.fieldName }}</h4>
                <b-button
                  v-if="c.fieldType == 9"
                  size="sm"
                  variant="light"
                  @click="displayConfig(c)"
                >
                  <i
                    class="tim-icons"
                    :class="
                      c.showConfig ? 'icon-minimal-up' : 'icon-minimal-down'
                    "
                  ></i>
                  {{ c.showConfig ? "Ocultar" : "Expandir" }}
                </b-button>
              </div>

              <b-form-group label="Tipo do campo" label-for="fieldType">
                <b-form-select
                  class="statusStyle"
                  :options="getOpt(c.fieldId)"
                  v-model="c.fieldType"
                >
                </b-form-select>
              </b-form-group>

              <div v-if="c.showConfig">
                <b-form-group
                  v-if="c.fieldType == 9"
                  label="Script de Pós-Processamento"
                  label-for="postCalculateScript"
                >
                  <div class="code-wrapper">
                    <custom-codemirror
                      :readonly="true"
                      :model.sync="c.postCalculateScript"
                    />
                    <b-button
                      variant="link"
                      class="copy-button"
                      v-b-tooltip.hover
                      title="Copiar código"
                      @click="copyToClipboard(c.postCalculateScript)"
                    >
                      <i class="tim-icons icon-single-copy-04"></i>
                    </b-button>
                  </div>
                </b-form-group>

                <div>
                  <h5 class="mt-2">Frentista</h5>
                  <b-form-checkbox
                    v-model="c.showAllOptions"
                    switch
                    class="mt-2"
                  >
                    Exibir todas as opções para o Frentista
                  </b-form-checkbox>
                </div>

                <!-- <b-form-group
                class="mt-3"
                label="Script de validação"
                label-for="validationScript"
              >
                <div class="code-wrapper">
                  <custom-codemirror
                    id="ScriptPythonValidation"
                    :readonly="true"
                    :model.sync="c.validationScript"
                  />
                  <b-button
                    variant="link"
                    class="copy-button"
                    v-b-tooltip.hover
                    title="Copiar código"
                    @click="copyToClipboard(c.validationScript)"
                  >
                    <i class="tim-icons icon-single-copy-04"></i>
                  </b-button>
                </div>
              </b-form-group> -->
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-form>

    <b-alert v-else show variant="warning">
      Você não tem permissão para acessar esta página.
    </b-alert>

    <!-- Toast para feedback de cópia -->
    <b-toast
      id="copy-toast"
      title="Copiado"
      auto-hide-delay="1500"
      toaster="b-toaster-bottom-right"
    >
      <strong>Script copiado!</strong>
    </b-toast>
  </div>
</template>

<script>
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";
export default {
  name: "FuelSupplyFieldConfiguration",
  props: {
    config: Array,
  },
  components: {
    CustomCodemirror,
  },
  created() {
    this.isRmsUser();

    // Inicializar showConfig para cada campo
    if (this.config) {
      this.config.forEach((field) => {
        if (!field.hasOwnProperty("showConfig")) {
          this.$set(field, "showConfig", false);
        }
      });
    }
  },
  data() {
    return {
      userRms: false,
      allExpanded: false,
      driverOptions: [
        { value: 9, text: "Calculado" },
        { value: 14, text: "Responsável" },
      ],
      vehicleOptions: [
        { value: 9, text: "Calculado" },
        { value: 20, text: "Equipamento" },
      ],
      codViagem: [
        { value: 9, text: "Calculado" },
        { value: 5, text: "Inteiro" },
      ],
    };
  },
  methods: {
    getOpt(fieldId) {
      if (fieldId === 900000023 || fieldId === 900000056) {
        return this.driverOptions;
      } else if (fieldId === 900000024) {
        return this.vehicleOptions;
      } else if (fieldId === 900000048) {
        return this.codViagem;
      }
      return [];
    },
    async isRmsUser() {
      try {
        const response = await this.$apiScheduler.get("/user/isRms");
        this.userRms = response.data;
      } catch (error) {
        console.error("Erro ao verificar permissão:", error);
        this.userRms = false;
      }
    },
    displayConfig(row) {
      if (row) {
        row.showConfig = !row.showConfig;
        this.$forceUpdate();
      }
    },
    toggleAllConfigs() {
      this.allExpanded = !this.allExpanded;
      this.config.forEach((field) => {
        field.showConfig = this.allExpanded;
      });
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$bvToast.show("copy-toast");
          })
          .catch((err) => {
            console.error("Erro ao copiar: ", err);
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$bvToast.show("copy-toast");
        } catch (err) {
          console.error("Erro ao copiar: ", err);
        }
        document.body.removeChild(textArea);
      }
    },
  },
};
</script>

<style scoped>
.field-container {
  border-bottom: 1px solid #eee;
}

.field-container:last-child {
  border-bottom: none;
}

.code-wrapper {
  position: relative;
}

.copy-button {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  font-size: 0.8rem;
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
}

.code-wrapper:hover .copy-button {
  opacity: 1;
}

.statusStyle {
  max-width: 300px;
}
</style>